<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  class="m-vertical-bar-chart">
</highcharts-chart>
